// AppShell breadcrumb — yol → etiket eşlemesi + saf parça hesabı (AppShell.tsx'ten taşındı).

// Breadcrumb için path → label mapping. Özel path'ler için üstüne biner.
export const PATH_LABELS: Record<string, string> = {
  "/": "Dashboard",
  "/projects": "Projeler",
  "/projects/import": "Geçmiş Rapor Aktarımı",
  "/archive": "Arşiv",
  "/clients": "Müşteriler",
  "/clients/kpi/ozet": "Müşteriler · Performans Göstergeleri · Özet",
  "/clients/kpi/tablo": "Müşteriler · Performans Göstergeleri · Veri Girişi",
  "/clients/kpi/import": "Müşteriler · Performans Göstergeleri · İçe Aktar",
  "/clients/kpi/setler": "Müşteriler · Performans Göstergeleri · Veri Yönetimi",
  "/clients/kpi/paketler": "Müşteriler · Performans Göstergeleri · Paketler",
  "/clients/kpi/katalog": "Müşteriler · Performans Göstergeleri · Katalog",
  "/clients/kpi/hedefler": "Müşteriler · Performans Göstergeleri · Hedefler",
  "/clients/kpi/disclosure": "Müşteriler · Performans Göstergeleri · Disclosure Hazırlık",
  "/admin/users": "Kullanıcılar",
  "/admin/roles": "Roller",
  "/admin/frameworks": "Çerçeve Yöneticisi · Çerçeveler",
  "/admin/frameworks/sector-packages": "Çerçeve Yöneticisi · Sektör Paketleri",
  "/admin/branding": "Branding",
  "/admin/settings": "Sistem Ayarları",
  "/admin/settings/prompt-library": "Sistem Ayarları · KK Prompt Library",
  "/admin/settings/llm": "Sistem Ayarları · LLM",
  "/admin/settings/mail": "Sistem Ayarları · Mail",
  "/admin/settings/prompt": "Sistem Ayarları · Prompt",
  "/admin/settings/budget": "Sistem Ayarları · Bütçe",
  "/admin/settings/ui": "Sistem Ayarları · Arayüz",
  "/admin/settings/evidence": "Sistem Ayarları · Kanıt Belgeleri",
  "/admin/settings/audit": "Sistem Ayarları · Audit Log",
};

/**
 * Breadcrumb parçaları. İç içe yolda son parça `detailLabel` (sayfanın verdiği ad — ör. müşteri
 * adı, Finar rev-A 15) ya da yoksa "Detay".
 */
export function computeCrumbs(pathname: string, detailLabel?: string | null): string[] {
  const exact = PATH_LABELS[pathname];
  if (exact) return [exact];
  // Nested path: ilk segmenti bul, sonra "Detay"
  const parts = pathname.split("/").filter(Boolean);
  if (parts.length === 0) return ["Dashboard"];
  const first = `/${parts[0]}`;
  const firstLabel = PATH_LABELS[first] ?? parts[0]!;
  if (parts.length === 1) return [firstLabel];
  const detail = detailLabel?.trim();
  return [firstLabel, detail === undefined || detail === "" ? "Detay" : detail];
}
